import 'arrive';

document.arrive('.block-form', { existing: true }, function () {
    document.addEventListener('DOMContentLoaded', function() {
    const dropZones = document.querySelectorAll('.gfield--type-fileupload');

    dropZones.forEach(zone => {
        const input = zone.querySelector('input[type="file"]');
        const container = zone.querySelector('.ginput_container_fileupload');
        const label = zone.querySelector('.gfield_label');

        if (!input || !container || !label) return;

        // Clicca su tutto il container per aprire il file picker
        container.addEventListener('click', () => {
        input.click();
        });

        // Drag & drop highlight
        container.addEventListener('dragover', e => {
        e.preventDefault();
        container.classList.add('dragover');
        });

        container.addEventListener('dragleave', () => {
        container.classList.remove('dragover');
        });

        container.addEventListener('drop', e => {
        e.preventDefault();
        container.classList.remove('dragover');
        input.files = e.dataTransfer.files;

        // Trigger change
        const event = new Event('change', { bubbles: true });
        input.dispatchEvent(event);
        });

        // Quando viene selezionato un file
        input.addEventListener('change', () => {
        const fileList = Array.from(input.files).map(f => f.name).join(', ');

        if (fileList) {
            // Aggiorna il contenuto della label
            label.textContent = `File selezionato: ${fileList}`;
            container.classList.add('has-file');
        } else {
            // Testo di default
            label.textContent = 'Carica il tuo CV *';
            container.classList.remove('has-file');
        }
        });
    });
    });



});